export default {
    aboutCompany: {}
};
